const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Newenham",

  webfeedDebuggerWebsiteUrl: "https://newenham.com.au/now-selling#/masterplan",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
